import { render, staticRenderFns } from "./DigitalMarketing-3.4.vue?vue&type=template&id=58a209e6&scoped=true&"
import script from "./DigitalMarketing-3.4.vue?vue&type=script&lang=js&"
export * from "./DigitalMarketing-3.4.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMarketing-3.4.vue?vue&type=style&index=0&id=58a209e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a209e6",
  null
  
)

export default component.exports